import React from "react";
import CalcSmall from "../../PicesForPages/calc-small.jpg";
import BuyDownCalculator from "../CalculatorAndChart/buyDownCalculator";

function BuyDone() {
  return (
    <div className="TodaysRatesCalculatorParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={CalcSmall}
          alt="RFamilyImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Buy Down Calculator</span>
        </div>
      </div>
      <div className="TodaysRatesCalculatorButtons">
        <BuyDownCalculator />
      </div>
    </div>
  );
}

export default BuyDone;
